export default __webpack_public_path__ + "static/media/check.51a59f39.png";